const errorMessageMap = {
  401: 'You are not authorized to take this action.',
  403: 'You are not authorized to take this action.',
  404: 'Something went wrong. Please try again later.',
  5000: 'Something went wrong. Please try again later.',
  500: 'Something went wrong. Please try again later.',
  1017: 'Invalid Credentials',
  1029: 'Subject update failed for invalid subjectId. Please try again later.',

  /*
        Custom
    */
  INVALID_PERM: "You don't have required permissions to access [pageName] page(s).",

  netWorkError: 'Something went wrong. Please try again later.',

  CRITICAL_DATA_ABSENT: '[critical] is absent for your selection.',

  // ERR_INTERNET_DISCONNECTED

  // Custom error messages
  // Maybe later on we can have a separate file.
  // SubjectManagement Error messages.
  createSubjectErrorMessage: "Failed to create subject '[subjectName]'. Please try again later.",
  deleteSubjectErrorMessage: "Failed to delete subject '[subjectName]'. Please try again later.",
  deleteSubjectPermissionErrorMessage: 'You dont have permission to delete subject(s).',
  updateSubjectErrorMessage: "Failed to update subject '[subjectName]'. Please try again later.",
  updateSubjectRoleErrorMessage:
    "You are not content admin for '[subjectName]'. Only a content admin can update name of the subject.",
  getSubjectAssigneeErrorMessage: "Failed to fetch assignees for subject '[subjectName]'.",
  getSubjectUnitsErrorMessage: "Failed to fetch units for subject '[subjectName]'.",

  createUnitErrorMessage: "Failed to create unit '[unitName]'. Please try again later.",
  deleteUnitErrorMessage:
    "Failed to delete unit(s) for subject '[subjectName]'. Please try again later.",
  updateUnitErrorMessage: "Failed to update unit '[unitName]'. Please try again later.",
  tableReorderErrorMessage: 'Failed to update units order. Please try again later.',
  sendForReviewErrorMessage: "Send for review failed for '[subjectName]'. Please try again later.",
  updateAssigneeErrorMessage:
    "Failed to update assignee for '[subjectName]'. Please try again later.",

  createTopicOrSubTopicErrorMessage: "Failed to create [type] '[name]'. Please try again later.",
  deleteTopicOrSubTopicErrorMessage: 'Failed to delete [type](s). Please try again later.',
  updateTopicOrSubTopicErrorMessage: "Failed to update [type] '[name]'. Please try again later.",
  reorderTopicOrSubTopicErrorMessage: 'Failed to update [type]s order. Please try again later.',
  attachVideoErrorMessage: 'Failed to attach video for [subTopicName]. Please try again later.',

  /* ************************************ [PUBLISHER] ************************************* */

  deleteCategoryWithSubcategories: 'You cannot delete a category with subcategory(s) in it.',
};

export { errorMessageMap };
